/**
 * R4 — canonical React Query key registry. ONE place that names the keys shared
 * across views, so the realtime SSE→invalidation map (R21) and every consumer
 * reference the SAME key and a push can never silently miss a surface. Seeded
 * with the work-summary key; extended as the redesign lands routed views.
 */
export const queryKeys = {
  /** The destination badge counts (count-truth). */
  workSummary: ['work-summary'] as const,
} as const;
